import classNames from 'clsx';
import mailSpaceDarkSrc from 'img/tariffCardHeader/mail-space/mail-space-dark.png';
import mailSpaceLightSrc from 'img/tariffCardHeader/mail-space/mail-space-light.png';
import mascotDarkSrc from 'img/tariffCardHeader/mascot/byte_dark.png';
import mascotLightSrc from 'img/tariffCardHeader/mascot/byte_light.png';
import React, { type FC } from 'react';
import { TariffCardHeaderMode } from 'reactApp/appHelpers/featuresHelpers/features/disableAdsScreen';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import styles from './TariffCardImageHeader.css';

type CoverConfig = Record<Exclude<TariffCardHeaderMode, TariffCardHeaderMode.none>, string>;
const imagesConfig: { dark: CoverConfig; light: CoverConfig } = {
    dark: {
        [TariffCardHeaderMode.mailSpace]: mailSpaceDarkSrc,
        [TariffCardHeaderMode.mascot]: mascotDarkSrc,
    },
    light: {
        [TariffCardHeaderMode.mailSpace]: mailSpaceLightSrc,
        [TariffCardHeaderMode.mascot]: mascotLightSrc,
    },
};

interface TariffCardImageHeaderProps {
    headerMode: TariffCardHeaderMode;
}

export const TariffCardImageHeader: FC<TariffCardImageHeaderProps> = ({ headerMode }) => {
    const darkTheme = isDarkThemeModeEnabled();
    const imageSrc = (darkTheme ? imagesConfig.dark[headerMode] : imagesConfig.light[headerMode]) || mascotLightSrc;

    return (
        <div
            className={classNames(styles.imageHeader, {
                [styles.mascot]: headerMode === TariffCardHeaderMode.mascot,
                [styles.mailSpace]: headerMode === TariffCardHeaderMode.mailSpace,
            })}
        >
            <div className={styles.wrapper}>
                <div className={styles.rack} />
                <img className={styles.img} src={imageSrc} />
            </div>
        </div>
    );
};
